import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch, onMounted } from 'vue'
import AppMarkdownEditor from './AppMarkdownEditor.vue'

/**
 * @deprecated This component is deprecated. Use AppMarkdownEditor instead.
 * This wrapper exists for backward compatibility only.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Simplemde',
  props: {
    value: { default: '' },
    modelValue: { default: '' },
    name: { default: 'editor' },
    rows: { default: 3 },
    autoHeight: { type: Boolean, default: false },
    minRows: { default: 3 },
    maxRows: { default: 20 }
  },
  emits: ["input", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const text = ref('')

// Get the actual value from either prop
const inputValue = computed(() => {
  return props.modelValue || props.value || ''
})

onMounted(() => {
  text.value = inputValue.value
})

watch(inputValue, (newVal) => {
  if (newVal !== text.value) {
    text.value = newVal
  }
})

watch(text, (newVal) => {
  emit('input', newVal)
  emit('update:modelValue', newVal)
})

const onInput = (value: string) => {
  text.value = value
  emit('input', value)
}

const onUpdateModelValue = (value: string) => {
  text.value = value
  emit('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppMarkdownEditor, {
    modelValue: text.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      onUpdateModelValue
    ],
    rows: __props.rows,
    name: __props.name,
    autoHeight: __props.autoHeight,
    minRows: __props.minRows,
    maxRows: __props.maxRows,
    onInput: onInput
  }, null, 8 /* PROPS */, ["modelValue", "rows", "name", "autoHeight", "minRows", "maxRows"]))
}
}

})